export default __webpack_public_path__ + "media/images/logos/monitoring_logo-476006044a1de8c06a518e270c1bd106.svg";